var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      attrs: {
        bottom: "",
        left: "",
        "min-width": "300px",
        "max-width": "320px",
        "close-on-content-click": false,
        "offset-y": "",
        transition: "slide-y-transition"
      },
      model: {
        value: _vm.menu,
        callback: function($$v) {
          _vm.menu = $$v
        },
        expression: "menu"
      }
    },
    [
      _c(
        "v-btn",
        { attrs: { slot: "activator", dark: "", icon: "" }, slot: "activator" },
        [
          _c(
            "v-badge",
            {
              attrs: { left: "", color: "accent", overlap: "" },
              model: {
                value: _vm.notifications.length,
                callback: function($$v) {
                  _vm.$set(_vm.notifications, "length", $$v)
                },
                expression: "notifications.length"
              }
            },
            [
              _c(
                "span",
                {
                  staticClass: "caption",
                  attrs: { slot: "badge" },
                  slot: "badge"
                },
                [_vm._v(_vm._s(_vm.notifications.length))]
              ),
              _vm._v(" "),
              _c("v-icon", [_vm._v("notifications")])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _vm.notifications.length
            ? _c(
                "v-subheader",
                { staticClass: "subheading accent white--text" },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$tc("newMessage", _vm.nbMessages, {
                          count: _vm.nbMessages
                        })
                      ) +
                      "\n    "
                  )
                ]
              )
            : _c(
                "v-subheader",
                { staticClass: "subheading accent white--text" },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm._f("cap")(_vm.$tc("notif", 0))) +
                      "\n    "
                  )
                ]
              ),
          _vm._v(" "),
          _vm.notifications.length
            ? _c(
                "v-btn",
                {
                  attrs: { color: "accent", flat: "", small: "" },
                  on: {
                    click: function($event) {
                      return _vm.$store.commit("_Notifier/CLEAR_ALL")
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { left: "", color: "accent" } }, [
                    _vm._v("clear_all")
                  ]),
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm._f("cap")(_vm.$t("clearAll"))) +
                      "\n    "
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-list",
            {
              staticClass: "listeNotifications",
              attrs: { "three-line": "", dense: "" }
            },
            [
              _vm._l(_vm.notifications, function(notif, i) {
                return _c(
                  "div",
                  { key: i },
                  [
                    notif.action.path && notif.type == "message"
                      ? _c(
                          "v-list-tile",
                          {
                            attrs: {
                              avatar: "",
                              to: { path: notif.action.path }
                            },
                            on: {
                              click: function($event) {
                                return _vm.clickNotif(i)
                              }
                            }
                          },
                          [
                            _c(
                              "v-list-tile-action",
                              [
                                _c(
                                  "v-badge",
                                  {
                                    attrs: { overlap: "", color: "red" },
                                    model: {
                                      value: notif.count,
                                      callback: function($$v) {
                                        _vm.$set(notif, "count", $$v)
                                      },
                                      expression: "notif.count"
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "caption",
                                        attrs: { slot: "badge" },
                                        slot: "badge"
                                      },
                                      [_vm._v(_vm._s(notif.count))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "accent--text",
                                        attrs: { "x-large": "" }
                                      },
                                      [_vm._v(_vm._s(notif.type))]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-list-tile-content",
                              [
                                notif.data.timestamp
                                  ? _c("v-list-tile-sub-title", [
                                      _c("i", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("dateTime")(
                                              notif.data.timestamp
                                            )
                                          )
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("v-list-tile-title", [
                                  _vm._v(_vm._s(notif.data.titre))
                                ]),
                                _vm._v(" "),
                                _c(
                                  "v-list-tile-sub-title",
                                  { staticClass: "contentNotif" },
                                  [
                                    _c("div", [
                                      _vm._v(_vm._s(notif.data.message))
                                    ])
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : notif.action.path &&
                        notif.target &&
                        notif.type == "error"
                      ? _c(
                          "v-list-tile",
                          {
                            attrs: {
                              href: notif.action.path,
                              target: "notif.target"
                            }
                          },
                          [
                            _c(
                              "v-list-tile-action",
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "red--text",
                                    attrs: { "x-large": "" }
                                  },
                                  [_vm._v(_vm._s(notif.type))]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-list-tile-content",
                              [
                                notif.data.timestamp
                                  ? _c("v-list-tile-sub-title", [
                                      _c("i", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("dateTime")(
                                              notif.data.timestamp
                                            )
                                          )
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("v-list-tile-title", [
                                  _vm._v(_vm._s(notif.data.titre))
                                ]),
                                _vm._v(" "),
                                _c(
                                  "v-list-tile-sub-title",
                                  { staticClass: "contentNotif" },
                                  [
                                    _c("div", [
                                      _vm._v(_vm._s(notif.data.message))
                                    ])
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : notif.action.path &&
                        !notif.target &&
                        notif.type == "error"
                      ? _c(
                          "v-list-tile",
                          { attrs: { to: { path: notif.action.path } } },
                          [
                            _c(
                              "v-list-tile-action",
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "red--text",
                                    attrs: { "x-large": "" }
                                  },
                                  [_vm._v(_vm._s(notif.type))]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-list-tile-content",
                              [
                                notif.data.timestamp
                                  ? _c("v-list-tile-sub-title", [
                                      _c("i", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("dateTime")(
                                              notif.data.timestamp
                                            )
                                          )
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("v-list-tile-title", [
                                  _vm._v(_vm._s(notif.data.titre))
                                ]),
                                _vm._v(" "),
                                _c(
                                  "v-list-tile-sub-title",
                                  { staticClass: "contentNotif" },
                                  [_c("div", [_vm._v("notif.data.message")])]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _c(
                          "v-list-tile",
                          {
                            attrs: { avatar: "" },
                            on: {
                              click: function($event) {
                                return _vm.clickNotif(i)
                              }
                            }
                          },
                          [
                            _c(
                              "v-list-tile-action",
                              [
                                _c(
                                  "v-badge",
                                  {
                                    attrs: { overlap: "", color: "red" },
                                    model: {
                                      value: notif.count,
                                      callback: function($$v) {
                                        _vm.$set(notif, "count", $$v)
                                      },
                                      expression: "notif.count"
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "caption",
                                        attrs: { slot: "badge" },
                                        slot: "badge"
                                      },
                                      [_vm._v(_vm._s(notif.count))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "orange--text",
                                        attrs: { "x-large": "" }
                                      },
                                      [_vm._v(_vm._s(notif.type))]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-list-tile-content",
                              [
                                notif.data.timestamp
                                  ? _c("v-list-tile-sub-title", [
                                      _c("i", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("dateTime")(
                                              notif.data.timestamp
                                            )
                                          )
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("v-list-tile-title", [
                                  _vm._v(_vm._s(notif.data.titre))
                                ]),
                                _vm._v(" "),
                                _c(
                                  "v-list-tile-sub-title",
                                  { staticClass: "contentNotif" },
                                  [_c("div", [_vm._v("notif.data.message")])]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                    _vm._v(" "),
                    _c("v-divider", {
                      key: i,
                      staticClass: "my-1",
                      attrs: { inset: "" }
                    })
                  ],
                  1
                )
              })
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9777f438", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9777f438","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzNotifications.vue
// module id = null
// module chunks = 